/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConciergeResultEntry } from './ConciergeResultEntry';
import {
  ConciergeResultEntryFromJSON,
  ConciergeResultEntryFromJSONTyped,
  ConciergeResultEntryToJSON,
} from './ConciergeResultEntry';

/**
 *
 * @export
 * @interface ConciergeResultsUpload
 */
export interface ConciergeResultsUpload {
  /**
   *
   * @type {Date}
   * @memberof ConciergeResultsUpload
   */
  startTime?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof ConciergeResultsUpload
   */
  endTime?: Date | null;
  /**
   *
   * @type {Array<ConciergeResultEntry>}
   * @memberof ConciergeResultsUpload
   */
  results: Array<ConciergeResultEntry>;
}

/**
 * Check if a given object implements the ConciergeResultsUpload interface.
 */
export function instanceOfConciergeResultsUpload(value: object): value is ConciergeResultsUpload {
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function ConciergeResultsUploadFromJSON(json: any): ConciergeResultsUpload {
  return ConciergeResultsUploadFromJSONTyped(json, false);
}

export function ConciergeResultsUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConciergeResultsUpload {
  if (json == null) {
    return json;
  }
  return {
    startTime: json['start_time'] == null ? undefined : new Date(json['start_time']),
    endTime: json['end_time'] == null ? undefined : new Date(json['end_time']),
    results: (json['results'] as Array<any>).map(ConciergeResultEntryFromJSON),
  };
}

export function ConciergeResultsUploadToJSON(value?: ConciergeResultsUpload | null): any {
  if (value == null) {
    return value;
  }
  return {
    start_time: value['startTime'] == null ? undefined : (value['startTime'] as any).toISOString(),
    end_time: value['endTime'] == null ? undefined : (value['endTime'] as any).toISOString(),
    results: (value['results'] as Array<any>).map(ConciergeResultEntryToJSON),
  };
}
